module.exports = __webpack_public_path__ + "img/milan1.905c737b.jpg";